export const INITIAL_BUSINESS_REQUEST = "INITIAL_BUSINESS_REQUEST";
export const FETCH_BUSINESS_SUCCESS = "FETCH_BUSINESS_SUCCESS";
export const FINAL_BUSINESS_REQUEST = "FINAL_BUSINESS_REQUEST";
